import * as api from '../api';
import { SHOW_CHAT, SHOW_CHAT_NOTIFICATIONS } from '../constants/actionTypes';

let defaultSettings = {
    showChat: false, 
    chatNotifications: []
}

export const showChatAction = (show = false) => {

    let action = {
        type: SHOW_CHAT,
        show
    };  

    return action; 
}

export const showChatNotification = (notification) => {

    let action = {
        type: SHOW_CHAT_NOTIFICATIONS,
        notification
    };  

    return action; 
}